import InitRouterView from '@common/InitRouterView'
import { HeaderView } from '@merchant-backend/common-components'
import {
  isWeddingDressProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import { getMerchantInfo } from '@util'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import DelCaseModal from '../Home/DelCaseModal'
import List from './List'
import Store from './store'
@InitRouterView()
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.store.updateMerchantInfo(getMerchantInfo()) //获取当前用户信息
  }

  render() {
    const Extra =
      isWeddingDressProperty() || isWeddingRingJewelryProperty() ? null : (
        <Button type="primary" onClick={this.store.publishFn}>
          发布案例
        </Button>
      )
    return (
      <HeaderView title="案例管理" {...this.props.viewData} extra={Extra}>
        <DelCaseModal
          visible={this.store.delCaseVisible}
          onCancel={() => {
            this.store.changeDelCaseVisible(false)
          }}
        />
        <List store={this.store} />
      </HeaderView>
    )
  }
}
